import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/Service/auth.service';
import { EventService } from 'src/app/Service/event.service';
import { SharedConstants } from 'src/app/models/index';
import { ConfirmationDialog } from '../../dialogs/ConfirmationDialog';
import * as L from 'leaflet';
import { ScheduleService } from 'src/app/Service/schedule.service';
import { ParentList } from '../groups/model/IGroups';
import { GroupsAdapterService } from '../groups/services/groups-adapter.service';
import { CaeUserEdit } from 'src/app/models/shared/cae-user';
import { utilsApps } from 'src/app/helpers/utils-app';
import { CaeUserService } from 'src/app/Service/cae-user-service.service';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import { NgOption } from '@ng-select/ng-select';
import { EnumStatusGeneric, EnumUserRol } from 'src/app/models/shared/app-enums';
import { HttpClient } from '@angular/common/http';
import { CatStatusGeneric } from 'src/app/models/shared/cat-status-generic';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-edit-cae-user',
  templateUrl: './edit-cae-user.component.html',
})
export class EditCaeUserComponent implements OnInit {
  @Input() childId: string;

  fmUser: FormGroup;
  currentUser: any;
  photo: File;
  catStatus: CatStatusGeneric[] = [];
  photoPreview: SafeUrl;
  protected hourList: string[] = [];
  _utils: utilsApps;
  _map: any;
  showMap: boolean = false;
  _ltd: number;
  _lng: number;
  _coordinates: any;
  _group: any = {
    contextual: '',
    name: ''
  };

  catMsg = [
    { keyLg: "warningAddService", textValue: "Para continuar es necesario seleccionar por lo menos un servicio." }
  ];

  /** For controller the confirms dialogs */
  public confirmationDialog: ConfirmationDialog = new ConfirmationDialog();
  public isConfirmationDialog: boolean = false;

  /** For use translate */
  protected msg_confirmDialog: string = "";
  protected msgTwo_confirmDialog: string = "";

  msg_address_not_found: string = "";

  regexImail: string;

  caeUserEntity: CaeUserEdit = {
    id: '',
    name: '',
    email: '',
    period_start: '',
    period_end: '',
    user_group_id: '',
    access_group_id: '',
    face: undefined,
    userId: 0,
    enabled: false,
    phone: '',
    password: '',
    title: '',
    department: ''
  };


  searchLabel: string = "";
  regexGeographicCoordinates: string;
  currentApiKey: string;
  branches: NgOption[] = [];
  selected: any[] = [];
  waitFor = false;
  data: any;

  public listAccessGroup: Array<ParentList> = [];
  public listUserGroup: Array<ParentList> = [];

  constructor(
    private sharedConstants: SharedConstants,
    private _fb: FormBuilder,
    private readonly http: HttpClient,
    private readonly scheduleService: ScheduleService,
    private translate: TranslateService,
    private authService: AuthService,
    private GroupsAdapterService: GroupsAdapterService,
    protected eventService: EventService,
    private sanitizer: DomSanitizer,
    private readonly _service: CaeUserService,
    private _modalService: NgbModal) {
    this.regexImail = this.sharedConstants.regexPattern.emailValidator;
    this.regexGeographicCoordinates = this.sharedConstants.regexPattern.geographicCoordinates;

    this.authService.currentUser.subscribe(resp => {
      if (resp === null || resp.username === undefined)
        this.currentUser = null;
      else
        this.currentUser = resp;

      console.log(this.currentUser);
    });

    this.fmUser = this._fb.group({
      name: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(48)]],
      phone: [''],
      email: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(50), Validators.pattern(this.regexImail)]],
      job_title: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(48)]],
      department: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
      accessGroupId: ['', [Validators.required]],
      userGroupId: ['', [Validators.required]],
      photo: [null, [Validators.required]],
      periodStartDate: ['', [Validators.required]],
      periodStartHour: ['', [Validators.required]],
      periodEndDate: ['', [Validators.required]],
      periodEndHour: ['', [Validators.required]],
      rbStatusId: ['', [Validators.required]]
    });

  }

  async ngOnInit(): Promise<void> {
    this.hourList = this.scheduleService.getListHours(60);


    this.getDataLanguage();
    this.onLoadEntity();


    this.catStatus = [
      {
        id: 1,
        name: "Activo",
        value: "1",
        keyLg: "Active"
      },
      {
        id: 0,
        name: "Inactivo",
        value: "0",
        keyLg: "Inactive"
      }
    ];

  }


  private async getAccessGroup(): Promise<Array<ParentList>> {
    let response = await this.GroupsAdapterService.getAccessGroup();
    console.log("getAccessGroup", response);
    console.log("getAccessGroup", response.data);

    if (response.status) {
      return response.data.map((group: any) => {
        console.log("getAccessGroup", group);
        return { id: group.id, name: group.name };
      });
    } else {
      return [];
    }

  }

  private async getUserGroup(): Promise<Array<ParentList>> {
    let response = await this.GroupsAdapterService.getUserGroup();
    if (response.status) {
      return response.data.map((group: any) => {
        return { id: group.id, name: group.name };
      });
    } else {
      return [];
    }
  }





  private async getListParent(): Promise<Array<ParentList>> {
    const company = this.getIdCompany();

    let response = await this.GroupsAdapterService.getGroupListRoot(company);
    if (response.status) {
      return response.data.records.map((group: any) => {
        return { id: group.contextual, name: group.name };
      });
    } else {
      return [];
    }
  }

  public getIdCompany(): number {
    if (this.currentUser) {
      if (this.currentUser.branches && this.currentUser.branches.length > 0) {
        return parseInt(this.currentUser.branches[0].idCompany);
      }
    }
    return 0;
  }


  onSave() {
    try {

      this.eventService.startLoadingData();
      this._utils = new utilsApps();
      const reader = new FileReader();
      let periodStartDate = this.fmUser.get("periodStartDate")?.value;
      let periodStartHour = this.fmUser.get("periodStartHour")?.value;
      let periodEndDate = this.fmUser.get("periodEndDate")?.value;
      let periodEndHour = this.fmUser.get("periodEndHour")?.value;

      let dateStart = this._utils.fnDateToString(periodStartDate, "-") + "T" + periodStartHour + ":00" + this._utils.GetTimeZoneOffset();
      let dateEnd = this._utils.fnDateToString(periodEndDate, "-") + "T" + periodEndHour + ":00" + this._utils.GetTimeZoneOffset();



      if (dateStart > dateEnd) {
        this.eventService.errorMessage(3, "cae-user.catMsg.DATE_NOT_VALID");
        this.eventService.completeLoadingData();
      } else {
        reader.readAsDataURL(this.photo);
        reader.onload = () => {
          let resultFile = reader.result;

          this.caeUserEntity.face = resultFile.toString().split(',')[1];
          this.caeUserEntity.period_start = dateStart;
          this.caeUserEntity.period_end = dateEnd;
          this.caeUserEntity.userId = this.currentUser.id;


          let request = {
            face: resultFile.toString().split(',')[1],
            name: this.fmUser.get("name")?.value,
            access_group: this.fmUser.get("accessGroupId")?.value,
            user_group: this.fmUser.get("userGroupId")?.value,
            email: this.fmUser.get("email")?.value,
            phone: this.fmUser.get("phone")?.value,
            position: this.fmUser.get("job_title")?.value,
            title: this.fmUser.get("job_title")?.value,
            department: this.fmUser.get("department")?.value,
            period_start: dateStart,
            period_end: dateEnd,
            id: this.caeUserEntity.id,
            userId: this.currentUser.id,
            enabled: this.fmUser.get("rbStatusId")?.value == "1" ? true : false
          };

          console.log(">>>>>>><<<<<<<<<<<<<<<<<<<<<<<");
          console.log(request);

          this._service.UpdateUserCae(request).subscribe({
            next: (response: any) => {
              console.log(response);
              let code = response?.body?.code;
              console.log("code===>>", code);
              if (code === "SUCCESS") {
                this.eventService.successMessage(1);
                this.onClose(1);

                //recargar pantalla
                setTimeout(() => {
                  window.location.reload();
                }, 3000);

              } else {

                let msg = "cae-user.catMsg.";
                if (code == "ALREADY_EXISTS" || code == "FILE_NOT_PERSISTED"
                  || code == "NOT_PERSISTED" || code == "CONNECTION_FAILURE"
                  || code == "INVALID_PARAM" || code == "INVALID_RESPONSE_identitum"
                  || code == "INVALID_SECURITY_CONFIG"
                  || code == "DUPLICATED") {
                  this.eventService.errorMessage(3, msg + code);
                } else if (code == "max-user-limit-reached") {
                  this.eventService.warningMessage(msg + code);
                }
                else {
                  this.eventService.errorMessage(2);
                }
              }
              this.eventService.completeLoadingData();
            },
            error: (error: Response) => {
              console.log(error);
              this.eventService.errorMessage(2);
              this.eventService.completeLoadingData();
            }
          });

        };
      }

    } catch (error) {
      this.eventService.completeLoadingData();
      console.log(error);
    }
  }

  onShowMap() {

    let coordinates = this.fmUser.get("coordinates")?.value;
    let coordinatesArray = coordinates.split(',');

    if (coordinatesArray.length == 2) {
      let ltd: number, lng: number;
      ltd = coordinatesArray[0];
      lng = coordinatesArray[1];
      this.showMap = !this.showMap;
      this.setMarkerToMap(ltd, lng);
    }
    else {
      this.fmUser.get('coordinates')?.updateValueAndValidity();
    }
  }

  loadMap() {

    console.log("Cargando mapa... ");
    let ltd, lng;
    ltd = 19.43899318656144;
    lng = -99.1780088846568;

    if (this._map == undefined) {
      this._map = L.map('map', {
        center: [ltd, lng],
        zoom: 18,
      });
      this.addGeoSearchControl();
    }

    const tiles = L.tileLayer(
      'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      {
        maxZoom: 18,
      }
    );
    tiles.addTo(this._map);

    //Evento click
    this._map.on('click', e => {

      //Elimina los marcadores previos
      this._map.eachLayer(function (layer) {
        if (layer.options && layer.options.pane === "markerPane") {
          layer.remove();
        }
      });

      let coor = e.latlng;
      let value = coor.lat + ',' + coor.lng;
      this.fmUser.get("coordinates").setValue(value);
      this.setMarkerToMap(coor.lat, coor.lng);
    });

  }

  public setMarkerToMap(ltd: number, lng: number) {
    console.log("setMarkerToMap");

    //Elimina los marcadores previos
    this._map.eachLayer(function (layer) {
      layer.remove();
    });

    const greenIcon = new this.customLeafIcon({
      className: 'custom-green-marker',
    });

    let customMarker = greenIcon;

    //Crea y agrega el marcador
    L.marker([ltd, lng], { icon: customMarker, draggable: false })
      .addTo(this._map)
      .openPopup();

    //Agrega la capa del mapa
    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      {
        maxZoom: 18,
      }
    );
    tiles.addTo(this._map);
    //cambia posición del mapa
    this._map.panTo(new L.LatLng(ltd, lng));
  }

  private addGeoSearchControl(): void {
    const provider = new OpenStreetMapProvider();
    const control = GeoSearchControl({
      provider: provider,
      style: 'bar', // Optional: 'button' or 'bar'
      notFoundMessage: this.msg_address_not_found,
      autoComplete: true,
      searchLabel: this.searchLabel,
      autoCompleteDelay: 250,
      showMarker: false, // Optional: Show a marker when a location is found
    });
    this._map.addControl(control);
    console.log("Agregando control de búsqueda...");
  }

  customLeafIcon = L.DivIcon.extend({
    options: {
      html: "<div style='background-color:#4838cc;' class='marker-pin'></div>",
      iconSize: [30, 42],
      iconAnchor: [15, 42],
    },
  });


  get fmDet() { return this.fmUser.controls; }


  onCloseModalReference(name: string) {

  }

  onClearData() {

  }

  private getDataLanguage() {
    this.translate.stream('common.confirmDialog.messageCancel').subscribe((res: string) => {
      this.msg_confirmDialog = res;
    });
    this.translate.stream('common.confirmDialog.messageTwoCancel').subscribe((res: string) => {
      this.msgTwo_confirmDialog = res;
    });

    this.translate.stream('cae-user.catMsg.ADDRESS_NOT_FOUND').subscribe((res: string) => {
      this.msg_address_not_found = res;
    });

    this.translate.stream('cae-user.catMsg.SEARCHLABEL_CONTROL').subscribe((res: string) => {
      this.searchLabel = res;
    });

  }



  /**
   * For actions of by confirms dialogs, to do the correct process
   * @param $event For know the action to do
   */
  protected onClose(action: number): void {
    /** For active confirm dialog */
    if (action === 0) {
      this.confirmationDialog.keyConfirmDialog = "confirmExitCreateCAEUser";
      this.confirmationDialog.message = this.msg_confirmDialog;
      this.confirmationDialog.messageTwo = this.msgTwo_confirmDialog;
      this.isConfirmationDialog = true;
    }
    /** For confirm action of confirm dialog */
    if (action === 1) {
      this.onClearData();
      this._modalService.dismissAll();
    }
  }

  /**
   * For actions of by confirms dialogs, to do the correct process
   * @param $event For know the action to do
   */
  protected orchestratorCloseDialog($event: any): void {
    if (this.confirmationDialog.keyConfirmDialog === "confirmExitCreateCAEUser") {
      this.onClose($event);
    }
    this.isConfirmationDialog = false;
    this.confirmationDialog = new ConfirmationDialog();
  }


  protected setHour(hour: string, controlName: string): void {
    this.fmUser.get(controlName).setValue(hour);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      const file = input.files[0];

      if (file.size <= 2000000) {
        this.fmUser.get('photo').setValue(file);
        this.fmUser.get('photo')?.updateValueAndValidity();
        this.photo = file;
        // Previsualización de la imagen cargada, sanitizada
        const objectUrl = URL.createObjectURL(file);
        this.photoPreview = this.sanitizer.bypassSecurityTrustUrl(objectUrl);
      }
      else {
        this.eventService.errorMessage(3, "cae-user.catMsg.FILE_TOO_BIG");
      }
    }
  }

  public getDate(date: string) {
    let dataOnly = new Date(date);
    return dataOnly;
  }

  public getHour(date: string) {
    let array_date = date.split('T');
    let array_hour = array_date[1].split(':');
    let dataOnly = array_hour[0] + ':' + array_hour[1];
    return dataOnly;
  }

  public b64toBlob(b64Data, contentType) {

    contentType = contentType || '';
    let sliceSize = 512;

    let byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    let blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }


  async onLoadEntity() {
    try {

      this.eventService.startLoadingData();

      this.listAccessGroup = await this.getAccessGroup();
      this.listUserGroup = await this.getUserGroup();

      this._service.GetUserCae(this.childId).subscribe({
        next: res => {
          console.log(res);

          if (res.ok) {

            let resultData = res.body;
            this.caeUserEntity = JSON.parse(resultData.content);
            console.log("GetUserCae =>", this.caeUserEntity);

            //Llenar formulario
            let periodStartDate: Date;
            let periodStartHour: string;
            let periodEndDate: Date;
            let periodEndHour: string;

            if (this.caeUserEntity.period_start) {
              periodStartDate = this.getDate(this.caeUserEntity.period_start);
              periodEndDate = this.getDate(this.caeUserEntity.period_end);
            }

            periodStartHour = this.getHour(this.caeUserEntity.period_start);
            periodEndHour = this.getHour(this.caeUserEntity.period_end);

            if (this.caeUserEntity.face) {
              this.photo = this.dataURLtoFile(this.caeUserEntity.face, "photo.jpg");
            }

            let statusValue = this.caeUserEntity.enabled ? EnumStatusGeneric.Active : EnumStatusGeneric.Inactiva;

            this.fmUser = this._fb.group({
              name: [this.caeUserEntity?.name, [Validators.required, Validators.minLength(4), Validators.maxLength(48)]],
              email: [this.caeUserEntity.email, [Validators.required, Validators.minLength(10), Validators.maxLength(50), Validators.pattern(this.regexImail)]],
              photo: [this.caeUserEntity.face, [Validators.required]],
              periodStartDate: [periodStartDate, [Validators.required]],
              periodStartHour: [periodStartHour, [Validators.required]],
              periodEndDate: [periodEndDate, [Validators.required]],
              periodEndHour: [periodEndHour, [Validators.required]],
              phone: [this.caeUserEntity.phone],
              //password: [this.caeUserEntity.password, [Validators.required, Validators.minLength(3), Validators.maxLength(15)]],
              job_title: [this.caeUserEntity.title, [Validators.required, Validators.minLength(4), Validators.maxLength(48)]],
              department: [this.caeUserEntity.department, [Validators.required, Validators.minLength(3), Validators.maxLength(50)]],
              accessGroupId: [this.caeUserEntity.access_group_id, [Validators.required]],
              userGroupId: [this.caeUserEntity.user_group_id, [Validators.required]],
              rbStatusId: [statusValue.toString(), [Validators.required]],
            });

            if (this.caeUserEntity.face) {
              const blob = this.b64toBlob(this.caeUserEntity.face, 'image/jpeg');
              console.log("blob", blob);
              const url = URL.createObjectURL(blob);
              this.photoPreview = this.sanitizer.bypassSecurityTrustUrl(url);
            }

          }
          else {
            this.translate.stream('common.error500').subscribe((res: string) => {
              this.eventService.errorMessage(0, res);
            });
          }
          this.eventService.completeLoadingData();

        },
        error: error => {
          console.log(error);
        }
      });
    } catch (error) {
      console.log(error);
    }

  }


  dataURLtoFile(dataurl, filename, mimeParam: string = "image/jpeg") {
    let arr = dataurl.split(','),
      mime = mimeParam,
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

}